module.exports = __webpack_public_path__ + "img/person-sign.3d895769.svg";